import { Field, Label } from "@headlessui/react";
import React, { useState } from "react";
import * as Slider from "@radix-ui/react-slider";
import { AnimateNumber } from "motion-number";
import { useLookTransition } from "@/components/motion/LookMotion";

const NUMBER_TRANSITION = { duration: 0.2, ease: "easeOut" } as const;

const AreaSlider: React.FC<{ range: any; title: string; name: string }> = ({
  range,
  title,
  name,
}) => {
  const [value, setValue] = useState<number[]>([
    ...range.steps.map((x: any) => Number(x.value)),
  ]);
  const transition = useLookTransition(NUMBER_TRANSITION);

  const minValue = Number(range.steps[0].value);
  const maxValue = Number(range.steps[range.steps.length - 1].value);

  function renderLowerNumber() {
    return (
      <AnimateNumber
        className="font-bold"
        format={{
          style: "decimal",
        }}
        suffix="m²"
        transition={transition}
        style={{ originX: 0.5, originY: 1.5 }}
      >
        {value[0] as any}
      </AnimateNumber>
    );
  }

  function renderUpperNumber() {
    return (
      <AnimateNumber
        className="font-bold"
        transition={transition}
        format={{
          style: "decimal",
        }}
        suffix="m²"
        style={{ originX: 0.5, originY: 1.5 }}
      >
        {value[1] as any}
      </AnimateNumber>
    );
  }

  function getContent() {
    {
      if (value[0] === minValue && value[1] === maxValue) {
        return <span className="font-content">Alle</span>;
      } else if (value[0] === minValue) {
        return (
          <div className="flex gap-1">
            <span>op til</span>
            {renderUpperNumber()}
          </div>
        );
      } else if (value[1] === maxValue) {
        return (
          <div className="flex gap-1">
            <span>fra</span>
            {renderLowerNumber()}
          </div>
        );
      } else {
        return (
          <div className="flex gap-2 items-center">
            <span>fra</span>
            {renderLowerNumber()}
            <span>til</span>
            {renderUpperNumber()}
          </div>
        );
      }
    }
  }

  return (
    <Field className="flex flex-1 flex-col col-span-6 text-[var(--input-text-color)]">
      <Label className="flex gap-2 flex-1 justify-between md:justify-start">
        <div>{title}: </div>
        {getContent()}
      </Label>
      <Slider.Root
        defaultValue={value}
        step={range.stepSize}
        max={maxValue}
        min={minValue}
        value={value}
        name="asd"
        onValueChange={(values) => setValue(values)}
        minStepsBetweenThumbs={1}
        className="relative flex h-5 touch-none items-center"
      >
        <Slider.Track className="relative h-2 rounded-full w-full grow border border-[var(--slider-border-color)]">
          <Slider.Range className="absolute h-full rounded-full bg-[var(--re-slider-range,var(--input-bg-color))]" />
        </Slider.Track>
        <Slider.Thumb
          name={`min_${name}`}
          onDoubleClick={() => setValue([minValue, value[1]])}
          className="block size-5 cursor-pointer rounded-full border border-gray-300  bg-[var(--re-slider-thumb,white)] border-[var(--input-bg-color)]"
        />
        <Slider.Thumb
          name={`max_${name}`}
          onDoubleClick={() => setValue([value[0], maxValue])}
          className="block size-5 cursor-pointer rounded-full border border-gray-300  bg-[var(--re-slider-thumb,white)] border-[var(--input-bg-color)]"
        />
      </Slider.Root>
    </Field>
  );
};

export default AreaSlider;
